<template>
    <div class="order-items" :class="{ compact: isCompact }">
        <OrderItem
            v-for="orderItem in orderItems"
            :key="orderItem.id"
            :item="orderItem"
            :displayPrice="displayPrice ?? false"
        />
    </div>
</template>

<script setup lang="ts">
    import type { IOrderItem } from "@/data/model/Order";

    import OrderItem from "@/operator/components/order/OrderItem.vue";

    defineProps<{
        orderItems: IOrderItem[];
        displayPrice?: boolean;
        isCompact?: boolean;
    }>();
</script>

<style lang="scss"></style>
